import React, { useEffect } from "react";
import { FaEye, FaRegHeart } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  add_to_card,
  add_to_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import Rating from "../Rating";

const ShopProducts = ({ styles, products }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, successMessage } = useSelector((state) => state.card);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage]);

  // Same logic as Details.jsx: require login, then dispatch with a default
  // quantity of 1.
  const add_card = (id) => {
    if (userInfo) {
      dispatch(
        add_to_card({
          userId: userInfo._id,
          quantity: 1,
          productId: id,
        }),
      );
    } else {
      navigate("/login");
    }
  };

  const add_wishlist = (product) => {
    if (userInfo) {
      dispatch(
        add_to_wishlist({
          userId: userInfo._id,
          productId: product._id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          discount: product.discount,
          rating: product.rating,
          slug: product.slug,
        }),
      );
    } else {
      navigate("/login");
    }
  };

  return (
    <div
      className={`w-full grid ${styles === "grid" ? "grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2" : "grid-cols-1 md-lg:grid-cols-2 md:grid-cols-2"} gap-3 `}
    >
      {products.map((p, i) => (
        <div
          key={i}
          className={`flex transition-all duration-300 hover:shadow-card-hover hover:-translate-y-1.5 border border-slate-100 shadow-card ${styles === "grid" ? "flex-col justify-start items-start" : "justify-start items-center md-lg:flex-col md-lg:justify-start md-lg:items-start"} w-full gap-4 bg-white p-3 rounded-2xl group`}
        >
          <div
            className={
              styles === "grid"
                ? "w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden rounded-xl bg-slate-50"
                : "md-lg:w-full relative group h-[210px] md:h-[270px] overflow-hidden rounded-xl bg-slate-50"
            }
          >
            <img
              className="h-[240px] rounded-xl md:h-[270px] xs:h-[170px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              src={p.images[0]}
              alt=""
            />

            <ul className="flex transition-all duration-500 -bottom-12 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
              <li
                onClick={() => add_wishlist(p)}
                className="w-[40px] h-[40px] cursor-pointer bg-white shadow-md flex justify-center items-center rounded-full text-slate-600 hover:bg-[#059473] hover:text-white hover:scale-110 transition-all"
              >
                <FaRegHeart />
              </li>
              <Link
                to={`/product/details/${p.slug}`}
                className="w-[40px] h-[40px] cursor-pointer bg-white shadow-md flex justify-center items-center rounded-full text-slate-600 hover:bg-[#059473] hover:text-white hover:scale-110 transition-all"
              >
                <FaEye />
              </Link>
              <li
                onClick={() => add_card(p._id)}
                className="w-[40px] h-[40px] cursor-pointer bg-white shadow-md flex justify-center items-center rounded-full text-slate-600 hover:bg-[#059473] hover:text-white hover:scale-110 transition-all"
              >
                <RiShoppingCartLine />
              </li>
            </ul>
          </div>

          <div className="flex justify-start items-start flex-col gap-1 px-1 pb-1 w-full">
            <h2 className="font-semibold text-slate-800 truncate w-full">{p.name}</h2>
            <div className="flex justify-start items-center gap-3">
              <span className="text-md font-bold text-[#059473]">${p.price}</span>
              <div className="flex">
                <Rating ratings={p.rating} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShopProducts;
